import { Link } from 'react-router-dom';
import emblem from '../../../assets/images/ktzh-emblem.png';
import { cn } from '../layout.component';

type KtzhBrandProps = {
  collapsed?: boolean;
};

const KtzhBrand = ({ collapsed = false }: KtzhBrandProps) => (
  <Link to="/" className={cn('sidebar__brand', { 'sidebar__brand--collapsed': collapsed })} title="aivox">
    <img src={emblem} alt="ҚТЖ" className={cn('sidebar__brand-mark')} />
    {!collapsed && (
      <div className={cn('sidebar__brand-text')}>
        <span className={cn('sidebar__brand-title')}>aivox</span>
        <span className={cn('sidebar__brand-sub')}>ҚАЗАҚСТАН ТЕМІР ЖОЛЫ</span>
      </div>
    )}
  </Link>
);

export default KtzhBrand;
